import React, { Component } from 'react';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pass: ''
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const name = target.name;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        if (target.type === 'number') { value = Number(value) }

        this.setState({
            [name]: value
        });



    }
    render() {
        let greet = localStorage.getItem("name") || "Первый вход";
        return (
            <div className='logon-body'>
                <div>
                    
                    <h3 className='text-center'>Авторизация</h3>
                    {
                       greet 
                    }
                    <div className="form-group">
                        <input
                            name="pass"
                            type="password"
                            className="form-control "
                            placeholder="Enter password"
                            onChange={this.handleInputChange}
                            onKeyUp={(event) => {
                                if (event.keyCode == 13) {
                                    this.props.tryLogin(this.state.pass)
                                }
                            }} />
                    </div>
                    <button className="btn btn-primary btn-block mt-2 w-100 " onClick={() => { this.props.tryLogin(this.state.pass) }}>Submit</button>
                </div>
            </div>
        );
    }
}

export default Login;